/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import ReactApexChart from "react-apexcharts";

/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'

export class TitlesWithNoKeywordsLogChart extends Component {
    static displayName = TitlesWithNoKeywordsLogChart.name;

    constructor(props) {
        super(props);

        this.state = {
            mode: Constants.MODE_LOADING,
            options: {
                colors: ['#62e5c4', '#c1c1c1'],
                responsive: [{
                    breakpoint: 1500,
                    options: {
                        chart: {
                            width: 320,
                            height: 220
                        },
                        legend: {
                            position: 'right'
                        },
                        plotOptions: {
                            bar: {
                                columnWidth: '30%',
                            },
                        },
                    }
                }],
                chart: {
                    toolbar: {
                        show: false
                    },
                    stacked: true,
                    stackType: '100%'
                },
                grid: {
                    show: false,
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    shared: true,
                    x: {
                        format: 'MMM  dd yyyy'
                    },
                    y: {
                        formatter: function (val, index) {
                            return typing.numberWithCommas(val);
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '40%',
                    },
                },
                stroke: {
                    width: 2
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left',
                    style: {
                        fontSize: "20px",
                        fontWeight: 100,
                        color: '#666'
                    }
                },
                subtitle: {
                    text: 'Title without Keywords',
                    align: 'left',
                    style: {
                            fontWeight: 100
                        }
                },
                xaxis: {
                    type: 'datetime',
                    categories: [],
                },
                yaxis: {
                    show: false,
                    labels: {
                        show: false
                    }
                },
                legend: {
                    position: 'right',
                    floating: true,
                    fontWeight: 100
                }
            },
            series: [{
                name: '',
                data: []
            },
            {
                name: '',
                data: []
            }],
        }
    }


    load() {

        const self = this;

        ajax.get(Constants.ROUTE_API_DASHBOARD_TITLE_WITH_NO_KEYWORDS,
            {
                success: function (response) {

                    let optionsCopy = Object.assign({}, self.state.options);
                    let seriesCopyClients = [...self.state.series];
                    let seriesCopyFreeProfiles = [...self.state.series];
                    let seriesUpdatedClients = response.data.map(serie => serie.SUMMATION_TITLEWITHOUTKEYWORDS_CLIENTS);
                    let seriesTotalTilesClients = response.data.map(serie => serie.TOTALTITLES_CLIENTS);
                    let seriesUpdatedFreeProfiles = response.data.map(serie => serie.SUMMATION_TITLEWITHOUTKEYWORDS_FP);
                    let seriesTotalTitlesFreeProfiles = response.data.map(serie => serie.TOTALTITLES_FP);
                    
                    let labelsUpdated = response.data.map(label => label.LOGDATE);
                    let totalTitleswithoutKeywordClients = response.data[seriesUpdatedClients.length - 1].SUMMATION_TITLEWITHOUTKEYWORDS_CLIENTS;
                    let totalTitleswithoutKeywordFreeProfiles = response.data[seriesUpdatedFreeProfiles.length - 1].SUMMATION_TITLEWITHOUTKEYWORDS_FP;

                    let totalKeywords = totalTitleswithoutKeywordClients + totalTitleswithoutKeywordFreeProfiles;

                    const totalTitles_Client = response.data[seriesTotalTilesClients.length - 1].TOTALTITLES_CLIENTS;
                    const totalTitles_Freeprofiles = response.data[seriesTotalTitlesFreeProfiles.length - 1].TOTALTITLES_FP;
                    
                    // Clients: (contenido SIN KW C / contenido Client ) ) * 100
                    const percentClients = Math.round(( totalTitleswithoutKeywordClients / ( totalTitles_Client) )  *100);
                    
                    //FPS: (contenido SIN KW FP / contenido  FP ) * 100
                    const percentFreeProfiles = Math.round(( totalTitleswithoutKeywordFreeProfiles/ ( totalTitles_Freeprofiles) )  *100);
                   
                    

                    optionsCopy.xaxis.categories = labelsUpdated;
                    optionsCopy.title.text = typing.numberWithCommas(totalKeywords);
                    seriesCopyClients[0].data = seriesUpdatedClients;
                    seriesCopyFreeProfiles[0].data = seriesUpdatedFreeProfiles;

                    optionsCopy.subtitle.text = percentClients + '% Premium & ' + percentFreeProfiles +'% FPs solutions without a keyword in the title';

                    self.setState({
                        mode: Constants.MODE_LOADED,
                        options: optionsCopy,
                        series: [{
                            name: 'CLIENTS',
                            data: seriesUpdatedClients
                        },
                        {
                            name: 'FP',
                            data: seriesUpdatedFreeProfiles
                        }
                        ]
                    });
                }
            });
    }

    componentDidMount() {
        const self = this;
        self.load();
    }


    render() {

        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }

        return (
            <Fragment>
            <div className="chart-container">
              <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={320} />
            </div>
          </Fragment>
        )
    }
}






